<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
    <div class="container">
        <div class="row g-0">
            <div class="col-lg-6 col-md-6">
                <ul class="breadcrumb">
                    <li><a routerLink="/">Home</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><a routerLink="/events">Events</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><a routerLink="/events" fragment="cultural">Cultural</a></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li>Gurupornima Celebration</li>
                </ul>
                <div class="sec-title">
                    <h1><span>Gurupornima Celebration</span></h1>
                    <p>GHRCACS celebrate Gurupornima on 10th July 2025.
                    </p>
                    <p>On this Guru Purnima, GHRCACS Pune celebrated the guiding lights who shape minds and
                        inspire journeys.
                        A heartfelt tribute to the mentors who make learning meaningful</p>
                </div>
            </div>
        </div>
        <div class="breadcrumb-overlay overflow-hidden"
            style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima2.webp);">
        </div>
    </div>
  </section>
  <section class="section-lg">
    <div class="container">
      <div class="sec-title text-center">
          <h2><span>Photo Gallery</span></h2>
      </div>
      <div class="demo-gallery">
          <ul appLightgallery>
              <li class="grid-item1"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima1.webp">
                  </a>
              </li>
              <li class="grid-item2"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima2.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima2.webp">
                  </a>
              </li>
              <li class="grid-item3 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima3.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima3.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima3.webp">
                  </a>
              </li>
              <li class="grid-item4 "
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guru-pornima1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guru-pornima1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guru-pornima1.webp">
                  </a>
              </li>
              <li class="grid-item5 "
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/gurupournima1.webp">
                  </a>
              </li>
              <li class="grid-item6 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guru-pornima2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guru-pornima2.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/guru-pornima2.webp">
                  </a>
              </li>
          </ul>
      </div>
    </div>
  </section>
</main>
